/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import {
  requestClient,
  requestClientInfoAndTemplate,
  requestMarketingHomeInfo,
  requestRouterConfiguration
} from "../context/RequestManager";

// TODO: Find all these places where I should use this and replace it
// Also create this for: location, router, login page, marketing item, dashboard account
// Then go around app and make everything consistent

export const selectClient = (context, client) => {
  const { id, name } = client;
  context.updateState({
    clientId: id,
    clientSummary: { id, name }
  });
}

export const navigateToClient = ({
  contextUpdater,
  accountContext,
  client
}) => {
  // select item and to go business info page
  requestClientInfoAndTemplate({
    context: contextUpdater,
    token: accountContext.token,
    clientId: client.id,
    completion: () => {
      // set selected client
      selectClient(accountContext, client);
    },
    navigate: (_) => "/dashboard"
  });
};

export const navigateToLocation = ({
  contextUpdater,
  accountContext,
  client,
  locationId
}) => {
  // select item and to go business info page
  requestClientInfoAndTemplate({
    context: contextUpdater,
    token: accountContext.token,
    clientId: client.id,
    locationId: locationId,
    completion: () => {
      // set selected client
      selectClient(accountContext, client);
    },
    navigate: (_) => "/dashboard"
  });
};

export const navigateToRouter = ({
  contextUpdater,
  accountContext,
  client,
  router
}) => {
  const isAdmin = (accountContext.admin ?? false) || (accountContext.subAdmin ?? false);

  if (isAdmin) {
    // view router status if admin
    requestRouterConfiguration({
      context: contextUpdater,
      token: accountContext.token,
      clientId: client.id,
      macAddress: router.macAddress,
      navigate: (_) => "/router-status",
    });
  } else {
    // go to client info page if not admin
    requestClient({
      context: contextUpdater,
      token: accountContext.token,
      clientId: client.id,
      settingsPage: "",
      navigate: (_) => "/business-settings",
    });
  }
};

export const navigateToCaptivePortal = ({
  contextUpdater,
  accountContext,
  client,
  captivePortal,
}) => {
  // set selected client
  selectClient(accountContext, client);

  // request captive portal
  requestClient({
    context: contextUpdater,
    token: accountContext.token,
    clientId: client.id,
    navigate: (_) => "/login-page"
  });
};

export const navigateToAccount = ({
  contextUpdater,
  accountContext,
  client,
  account,
}) => {
  // set selected client
  selectClient(accountContext, client);

  // prepare for client page
  accountContext.updateState({
    initialViewState: { type: "account", id: account.id }
  });

  // request captive portal
  requestClient({
    context: contextUpdater,
    token: accountContext.token,
    clientId: client.id,
    settingsPage: "",
    navigate: (_) => "/business-settings"
  })
}

export const navigateToMarketing = ({
  contextUpdater,
  accountContext,
  client,
  item,
}) => {
  // set selected client
  selectClient(accountContext, client);

  // fetch marketing info and navigate to marketing page
  requestMarketingHomeInfo({
    context: contextUpdater,
    token: accountContext.token,
    clientId: client.id,
    highlightType: item.marketingType,
    highlightId: item.id,
    navigate: (_) => "/marketing"
  });
};
